export default function SessionsSkeleton({ count = 6 }: { count?: number }) {
  return (
    <div className="flex gap-4 border rounded-md items-center animate-pulse">
      {/* Left: sessions list skeleton */}
      <div className="w-1/2 max-h-[calc(100vh-148px)] overflow-y-auto p-2">
        <div className="space-y-2">
          {Array.from({ length: count }).map((_, i) => (
            <div key={i} className="p-3 rounded-md border bg-white">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-3 w-full">
                  <div className="flex items-center gap-2">
                    <div className="h-4 w-40 bg-gray-200 rounded" />
                    <div className="h-4 w-4 bg-gray-100 rounded-full" />
                    <div className="h-4 w-36 bg-gray-200 rounded" />
                  </div>
                  <div className="flex items-center gap-2 ml-auto">
                    <div className="h-5 w-16 bg-gray-200 rounded-full" />
                    <div className="h-5 w-14 bg-gray-100 rounded-full" />
                  </div>
                </div>
              </div>
              <div className="flex items-center gap-2 mt-2 text-xs text-gray-500">
                <div className="h-4 w-20 bg-gray-100 rounded" />
                <div className="h-4 w-28 bg-gray-200 rounded" />
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Right: doughnut chart skeleton */}
      <div className="w-1/2 h-full p-4 flex flex-col items-center justify-center">
        <div className="w-full flex flex-col items-center gap-4">
          <div className="relative w-[300px] h-[300px]">
            <div className="absolute inset-0 rounded-full bg-gray-100" />
            <div className="absolute inset-10 rounded-full bg-white" />
          </div>
          <div className="flex gap-6">
            <div className="h-4 w-40 bg-gray-200 rounded" />
            <div className="h-4 w-40 bg-gray-100 rounded" />
          </div>
          <div className="h-4 w-64 bg-gray-100 rounded" />
        </div>
      </div>
    </div>
  );
}
